import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-detail',
  templateUrl: './event-detail.component.html',
  styleUrls: ['./event-detail.component.scss']
})
export class EventDetailComponent implements OnInit {

  @Input() year: string;
  @Input() bgImg: string;

  constructor() { }

  ngOnInit(): void {
  }

}
